module.exports = __webpack_public_path__ + "img/icon-map.83ea7859.svg";